module.exports = __webpack_public_path__ + "static/img/logo.ff6ad208.png";